import React from "react"
import { Outlet } from "react-router-dom"
import styles from './PlayerContainer.module.css'

export const PlayerContainer = () => {
    return <div 
        className={styles.playerContainer}
        >
        <Outlet />
    </div>
}